/* eslint-disable max-len */

export const DEFAULT_STORE_ZIP = '30339';

export const SPEC_TITLE = 'Details';
export const APPLIANCE_CATEGORY = 'Appliance Category';
export const CATEGORY_ACCESSORY_MAPPING = {
  Refrigerator: 'Water Filter Replacement Model#'
};
export const KPF_MATCH = 'Model Compatibility';

export const FS_MAPPING = {
  PIP: 'enableCompatibleAccessoriesPIP',
  PAS: 'enableCompatibleAccessoriesPAS'
};
export const TARGET_MAPPING = {
  PIP: '_self',
  PAS: '_blank'
};

export const TOOL_TIP_TEXT_MAPPING = {
  Refrigerator: 'Your refrigerator will come with one water filter, however, water filters need to be replaced every 3 to 6 months, depending on consumption.'
};

// These are just what we know about and is current, these are subject to change.
export const EDGE_CASES_TO_IGNORE = [
  '0',
  '00000',
  'no',
  'No',
  'nO',
  'NO',
  'na',
  'Na',
  'nA',
  'NA',
  'n/a',
  'N/a',
  'n/A',
  'N/A',
  '.NA',
  'N.A',
  'NA.',
  'none',
  'None',
  'not applicable',
  'Not applicable',
  'not Applicable',
  'Not Applicable',
  'Models bought pre-Nov 2023: EDR4RXD1 Models bought post-Nov 2023: EDRARXD1',
  'Models bought pre-Nov 2023: EDR4RXD1 Models bought post-Nov 2023: EDRARXD1.',
  'RPWFE or XWFE – see refrigerator filter compartment to determine correct filter',
  'RPWFE or XWFE – see refrigerator filter compartment to determine correct filter.',
  'MWF on select models manufactured prior to June 2018. XWF on select models manufactured after June 2018',
  'MWF on select models manufactured prior to June 2018. XWF on select models manufactured after June 2018.'
];
